type Locale = 'en' | 'de';

/**
 * German names of the generic catalog models (OIL-121): "Boom stand, tall" must not show up in
 * the German UI. Keyed by the English model; branded models keep their names.
 */
const GENERIC_DE: Readonly<Record<string, string>> = {
  'Passive DI': 'Passive DI',
  'Active DI': 'Aktive DI',
  'Stereo DI (passive)': 'Stereo-DI (passiv)',
  'Stereo DI (active)': 'Stereo-DI (aktiv)',
  'USB / laptop DI': 'USB-/Laptop-DI',
  'Wedge 12"': 'Monitorbox 12"',
  'Wedge 15"': 'Monitorbox 15"',
  Sidefill: 'Sidefill',
  'IEM bodypack': 'In-Ear-Empfänger (Taschensender)',
  'Personal monitor mixer': 'Persönlicher Monitormischer',
  '32/16 stagebox': 'Stagebox 32/16',
  'Sub-core 8ch': 'Sub-Multicore 8 Kanäle',
  'Sub-core 12ch': 'Sub-Multicore 12 Kanäle',
  'Sub-core 16ch': 'Sub-Multicore 16 Kanäle',
  'Schuko power strip 6-way': 'Schuko-Steckdosenleiste 6-fach',
  'CEE16 distro (6x Schuko)': 'CEE16-Verteiler (6× Schuko)',
  'CEE32 distro (2x CEE16, 6x Schuko)': 'CEE32-Verteiler (2× CEE16, 6× Schuko)',
  'US power strip 120 V (6-way)': 'US-Steckdosenleiste 120 V (6-fach)',
  'Moving head spot': 'Moving Head Spot',
  'Moving head wash': 'Moving Head Wash',
  'Moving head beam': 'Moving Head Beam',
  'LED PAR': 'LED-PAR',
  'LED bar': 'LED-Bar',
  'LED wash panel': 'LED-Fluter',
  'Profile spot (ellipsoidal)': 'Profilscheinwerfer',
  'Fresnel 1 kW': 'Stufenlinse 1 kW',
  'Blinder 2-lite': 'Blinder 2-fach',
  Strobe: 'Stroboskop',
  'Follow spot': 'Verfolger',
  'Truss 1 m (29 cm, 4-point)': 'Traverse 1 m (29 cm, 4-Punkt)',
  'Truss 2 m (29 cm, 4-point)': 'Traverse 2 m (29 cm, 4-Punkt)',
  'Truss 3 m (29 cm, 4-point)': 'Traverse 3 m (29 cm, 4-Punkt)',
  'Truss corner 90° (29 cm, 4-point)': 'Traversenecke 90° (29 cm, 4-Punkt)',
  'Truss circle Ø 4 m (29 cm, 4-point)': 'Traversenkreis Ø 4 m (29 cm, 4-Punkt)',
  'Network switch 8-port': 'Netzwerk-Switch 8 Ports',
  'Digital console': 'Digitalpult',
  'Riser 2x1 m': 'Podest 2 × 1 m',
  'Riser 2x2 m': 'Podest 2 × 2 m',
  'Riser 1x1 m': 'Podest 1 × 1 m',
  'Chair (no armrests)': 'Stuhl ohne Armlehnen',
  'Chair with armrests': 'Stuhl mit Armlehnen',
  'Stool (no backrest)': 'Hocker ohne Lehne',
  'Bar stool': 'Barhocker',
  'Music stand': 'Notenpult',
  'Boom stand, tall': 'Galgenstativ, hoch',
  'Boom stand, short': 'Galgenstativ, kurz',
  'Boom stand, low-profile tripod': 'Galgenstativ, flaches Dreibein',
  'Straight stand, round base': 'Gerades Stativ, Rundfuß',
  'Overhead stand': 'Overhead-Stativ',
  'Speaker stand (35 mm)': 'Boxenstativ (35 mm)',
  'Lighting stand with T-bar': 'Lichtstativ mit T-Bar',
  'Truss lift (crank stand)': 'Kurbelstativ (Traversenlift)',
  'Desk stand': 'Tischstativ',
  'Drum mic clamp': 'Trommel-Mikroklemme',
};

/** The model name in the UI language: generic (unbranded) models are translated. */
export function localModel(
  model: string,
  brand: string | undefined,
  locale: Locale = 'en',
): string {
  if (locale !== 'de' || (brand !== undefined && brand !== '' && brand !== 'Generic')) return model;
  return GENERIC_DE[model] ?? model;
}
